import { useState } from 'react';
import { Button } from '../Button/Button';
import Combobox from '../Combobox/Combobox';
import { Actions, Wrapper } from './SaveToProject.style';

export type SaveToProjectProps = {
  onCta: (id: string) => void;
  onCancel: () => void;
  projects: IProject[];
};

export function SaveToProject(props: SaveToProjectProps) {
  const { projects } = props;
  const [value, setValue] = useState<string | null>(null);

  function onCta() {
    if (!value) return;
    props.onCta(value);
  }

  function onChange(newValue: any) {
    setValue(newValue);
  }

  const options = projects
    .filter((project) => project.type !== 'playground')
    .map((project) => ({
      id: project.id,
      text: `${project.emoji} ${project.name}`,
    }));

  return (
    <Wrapper className='SaveToProject-wrapper' data-testid='SaveToProject-wrapper'>
      <Combobox
        value={value}
        placeholder='Choose a project'
        options={options}
        onChange={onChange}
      />
      <Actions>
        <Button onClick={props.onCancel} variant='outline' color='pink'>
          Cancel
        </Button>
        <Button onClick={onCta} color='pink'>
          Save
        </Button>
      </Actions>
    </Wrapper>
  );
}

export default SaveToProject;
